import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-content-type-selector',
    templateUrl: './content-type-selector.component.html',
    styleUrls: ['./content-type-selector.component.scss'],
    standalone: false
})
export class ContentTypeSelectorComponent {
  @Input() label: string = 'Content Type';
  @Input() name: string = 'ddContentType';
  @Input() contentTypeId: string = '1';
  @Input() isAuxUnit: boolean = false;
  @Input() isDoubleDeckUnit: boolean = false;
  
  @Output() contentTypeIdChange = new EventEmitter<string>();
  @Output() contentTypeChange = new EventEmitter<any>();

  onContentTypeChange(event: any): void {
    this.contentTypeIdChange.emit(this.contentTypeId);
    this.contentTypeChange.emit(event);
  }
}
